<section class="step-three showLogin">
  <div class="close-box pointer logo mar-bot-20">
    <img
      [src]="GlobalConstants.data.logo.modal_url" class="img-fluid login-client-logo">
  </div>
  <form [formGroup]="addCardForm" (submit)="addCardFormSubmit()">
    <div class="flex">

    <div class="title">
      <ng-container i18n>Enter</ng-container> <span i18n>first 8 digits</span>

      <span><ng-container i18n>of your</ng-container> {{GlobalConstants.data.titles.card_name}}</span>
    </div>
    <div *ngIf="GlobalConstants.data.card_num_type == 'first8' && GlobalConstants.client === 'smeoffers'" class="justify-end pad-top-10">
      <img [src]="GlobalConstants.data.assets.img.visa_secure.img"  [ngStyle]="{'height': GlobalConstants.data.assets.img.visa_secure.height+ 'px','width': GlobalConstants.data.assets.img.visa_secure.width+ 'px'}" class="img-fluid" [alt]="GlobalConstants.data.assets.img.visa_secure.name">
    </div>
  </div>


    <div class="card-block">

      <label i18n>Card Number</label>
      <div class="flex main-flex">
        <div class="flex-3 pd-r7">
          <input type="text" #firstFocusable id="first_four_card_digits" class="form-control"
            (keyup)="onKeyph($event); keytab($event, focusable);checkbtn()" formControlName="binFirst4"
            autocomplete="off" minlength="4" maxlength="4" required>
        </div>
        <div class="flex-3 pd-l7">
          <input type="text" #focusable id="last_four_card_digits" class="form-control" formControlName="binLast4"
            autocomplete="off" minlength="4" maxlength="4"
            (keyup)="onKeyph($event);backkeytab($event, firstFocusable);checkbtn()" required>
        </div>
        <div class="flex-3 pd-r7">
          <div class="form-single-container">
            <input type="text" class="form-control text-center disabled" placeholder="XXXX" autocomplete="none"
              disabled>
          </div>
        </div>
        <div class="flex-3 pd-r7">
          <div class="form-single-container">
            <input type="text" class="form-control text-center disabled" (keyup)="onKeyph($event)"
              placeholder="XXXX" disabled>
          </div>
        </div>

      </div>
    </div>

    <div class="modal-foot mar-bot-50 pad-bot-20 clearfix">
      <div class="error-txt fnt-12 f500 pad-top-10" *ngIf="binError && GlobalConstants.client!='smeoffers' ">
        <span i18n>Please enter a valid Visa card number</span>
      </div>
      <div class="error-txt fnt-12 f500 pad-top-10" *ngIf="binError  && GlobalConstants.client=='smeoffers'">
        <span *ngIf="GlobalConstants.data.card_num_type == 'first4_last4'">{{GlobalConstants.data.content.bin_error.first4_last4}}</span>
        <span *ngIf="GlobalConstants.data.card_num_type == 'first6'">{{GlobalConstants.data.content.bin_error.first6}}</span>
        <span *ngIf="GlobalConstants.data.card_num_type == 'first8'">{{GlobalConstants.data.content.bin_error.first8}}</span>
      </div>

      <button i18n class="btn btn-theme " *ngIf="!btnActive" type="submit" disabled="disabled">Continue</button>
      <button class="btn btn-theme relative" *ngIf="btnActive" type="submit"
        [ngStyle]="{'background': GlobalConstants.data.colors.mainBtn_color}"><ng-container i18n>Continue</ng-container> <div class="small-loader input-load merged-card-loader" *ngIf="isload2"></div></button>


      <div class="mar-top-30" *ngIf="GlobalConstants.data.personalized_config.has_add_card_text">
        <div class="fnt-13" [ngStyle]="{'color': GlobalConstants.data.colors.active_text_color}">
          {{GlobalConstants.data.content.add_card_text}}</div>
      </div>
    </div>
    <div class="flex last-b">
      <div class="ll" i18n>Your Card/ Account parameters are used only to check eligibility and are encrypted</div>
      <div class="rr">
        <img src="./assets/img/logos/PCI.svg">
      </div>

    </div>
  </form>
</section>
